export const MESSAGING_ROOT_MESSAGE_BEGIN = "MESSAGING_ROOT_MESSAGE_BEGIN";
export const MESSAGING_ROOT_MESSAGE_SUCCESS = "MESSAGING_ROOT_MESSAGE_SUCCESS";
export const MESSAGING_ROOT_MESSAGE_ERROR = "MESSAGING_ROOT_MESSAGE_ERROR";

export const MESSAGING_CHILDREN_MESSAGE_BEGIN = "MESSAGING_CHILDREN_MESSAGE_BEGIN";
export const MESSAGING_CHILDREN_MESSAGE_SUCCESS = "MESSAGING_CHILDREN_MESSAGE_SUCCESS";
export const MESSAGING_CHILDREN_MESSAGE_ERROR = "MESSAGING_CHILDREN_MESSAGE_ERROR";

export const MESSAGING_POST_MESSAGE_BEGIN = "MESSAGING_POST_MESSAGE_BEGIN";
export const MESSAGING_ON_POST_MESSAGE_SUCCESS = "MESSAGING_ON_POST_MESSAGE_SUCCESS";
export const MESSAGING_POST_MESSAGE_SUCCESS = "MESSAGING_POST_MESSAGE_SUCCESS";
export const MESSAGING_POST_MESSAGE_ERROR = "MESSAGING_POST_MESSAGE_ERROR";

export const MESSAGING_GET_UNREAD_COUNT_BEGIN = "MESSAGING_GET_UNREAD_COUNT_BEGIN";
export const MESSAGING_GET_UNREAD_COUNT_SUCCESS = "MESSAGING_GET_UNREAD_COUNT_SUCCESS";
export const MESSAGING_GET_UNREAD_COUNT_ERROR = "MESSAGING_GET_UNREAD_COUNT_ERROR";



// WEBPACK FOOTER //
// ./actions/messagingActionTypes.js